// src/Services/paneerRewardService.js
//
// Jo bhi "Milk" subscriptions kam se kam 90 din (3 month) se active hain, unko
// har 30 din baad ek free Paneer 200g milta hai (agle din ki delivery mein free
// order ke roop mein add ho jata hai). Isko ek admin button se manually chala
// sakte ho, ya niche diye gaye Cloud Function snippet se daily auto-chala sakte ho.

import db, { firebase } from "../Firebase";
import moment from "moment";

// ---------- Config: yaha se tweak karo ----------
const ELIGIBLE_PRODUCT_KEYWORD = "Milk"; // subscription ka product_name isse match hona chahiye
const QUALIFY_AFTER_DAYS = 90;           // pehla paneer 90 din (3 month) baad
const REPEAT_EVERY_DAYS = 30;            // uske baad har 30 din mein ek aur paneer
const PANEER_PRODUCT_NAME = "Paneer";
const PANEER_PACKAGE_UNIT = "200 g";
const PANEER_MRP = 90; // sirf activity log / description ke liye, order free (0) jaayega
const REWARD_ORDER_TYPE = "Free Paneer Reward";

// ---------- helpers ----------
const daysSince = (sub) => {

  const effectiveDate = sub.resume_date ? sub.resume_date : sub.start_date;
  
  const start = effectiveDate?.toDate ? effectiveDate.toDate() : new Date(effectiveDate);
  return moment().startOf("day").diff(moment(start).startOf("day"), "days");
};

const generateOrderId = () => {
  const ts = Date.now().toString();
  const rand = Math.floor(Math.random() * 100);
  return (ts % 100000000).toString().padStart(6, "0") + rand.toString().padStart(2, "0");
};


const getAlreadyGivenCount = async (subscriptionId) => {
  const snap = await db
    .collection("order_history")
    .where("subscription_id", "==", subscriptionId)
    .where("order_type", "==", REWARD_ORDER_TYPE)
    .get();
  return snap.size;
};


const getCyclesCompleted = (sub) => {
  const activeDays = daysSince(sub); // yahan sirf sub pass karein
  if (activeDays < QUALIFY_AFTER_DAYS) return 0;
  return Math.floor((activeDays - QUALIFY_AFTER_DAYS) / REPEAT_EVERY_DAYS) + 1;
};

/**
 * Saari active Milk subscriptions check karke, jo bhi 3-month (ya uske multiple)
 * complete kar chuki hain unko free Paneer dega:
 *  - order_history mein ek free (price 0) order entry (agle din deliver hoga)
 *  - customer_activities mein ek log entry
 * "Already reward mil chuka hai kya" ye order_history mein pehle se maujood
 * REWARD_ORDER_TYPE entries count karke nikala jaata hai — subscription doc
 * mein koi naya field add/update nahi hota.
 *
 * @returns {{ checked: number, rewarded: Array<{customer_name, subscription_id, rewardsGiven}> }}
 */
export const runFreePaneerRewards = async () => {
  const snapshot = await db
    .collection("subscriptions_data")
    .where("status", "==", "1") // sirf active subscriptions
    .get();

  const rewarded = [];
  let checked = 0;

  for (const docSnap of snapshot.docs) {
    const sub = docSnap.data();
    checked++;

    // sirf Milk subscriptions eligible hain
    if (!sub.product_name || !sub.product_name.includes(ELIGIBLE_PRODUCT_KEYWORD)) {
      continue;
    }

    const cyclesCompleted = getCyclesCompleted(sub);
    if (cyclesCompleted <= 0) continue;

    const alreadyGiven = await getAlreadyGivenCount(sub.subscription_id);
    const dueCount = Math.max(0, cyclesCompleted - alreadyGiven);
    if (dueCount <= 0) continue;

    for (let i = 0; i < dueCount; i++) {
      const orderId = generateOrderId();
      const deliveryDate = moment().add(1, "day").format("YYYY-MM-DD");

      // Free paneer ko ek adhoc order ki tarah add kar rahe hain, taaki ye
      // normal delivery/picking flow mein wahi dikhe jahan baaki orders dikhte hain
      await db.collection("order_history").add({
        order_id: orderId,
        order_type: REWARD_ORDER_TYPE,
        customer_id: sub.customer_id,
        customer_name: sub.customer_name,
        customer_phone: sub.customer_phone,
        delivering_to: sub.delivering_to || "",
        hub_name: sub.delivered_by || "",
        delivery_exe_id: sub.delivery_exe_id || "",
        delivery_date: deliveryDate,
        delivery_time: "00:00:00",
        delivery_timestamp: new Date(deliveryDate),
        product_name: PANEER_PRODUCT_NAME,
        package_unit: PANEER_PACKAGE_UNIT,
        price: 0, // free
        quantity: 1,
        tax: 0,
        handling_charges: 0,
        total_amount: 0,
        status: "0", // naya order, abhi delivered nahi hua
        subscription_id: sub.subscription_id || "0",
        utilised_wallet_balance: 0,
        utilised_credit_limit: 0,
        created_date: new Date(),
        updated_date: new Date(),
      });

      await db.collection("customer_activities").add({
        customer_id: sub.customer_id,
        customer_name: sub.customer_name,
        customer_phone: sub.customer_phone,
        object: "Offer",
        action: "Free Paneer with Milk Subscription",
        description: `Subscription ID: ${sub.subscription_id} ne ${QUALIFY_AFTER_DAYS} din (3 month) complete kiye — free 1 Paneer ${PANEER_PACKAGE_UNIT} (₹${PANEER_MRP} value) delivery date ${deliveryDate} ke liye add kiya gaya`,
        user: "System",
        date: new Date(),
        created_date: new Date(),
      });
    }

    rewarded.push({
      customer_name: sub.customer_name,
      subscription_id: sub.subscription_id,
      rewardsGiven: dueCount,
    });
  }

  return { checked, rewarded };
};

export const getThreeMonthOldSubscriptions = async () => {
  const snapshot = await db
    .collection("subscriptions_data")
    .where("status", "==", "1") // Sirf active subscriptions
    .get();

  const eligibleUsers = [];

  snapshot.forEach((docSnap) => {
    const sub = docSnap.data();

    // Sirf Milk subscriptions (ELIGIBLE_PRODUCT_KEYWORD use karna best rahega)
    if (!sub.product_name || !sub.product_name.includes("Cow's Milk")) return;

    // 🔥 YAHAN CHANGE KIYA HAI: ab ye helper function use karega jisme 
    // resume_date ka logic pehle se handle hai
    const daysActive = daysSince(sub);

    // Agar 90 din (3 month) ya usse zyada ho gaye hain (resumed date se ya start date se), toh list me daalo
    if (daysActive >= 90) {
      eligibleUsers.push({
        customer_id: sub.customer_id,
        subscription_id: sub.subscription_id,
        customer_name: sub.customer_name,
        product_name: sub.product_name,
        days_active: daysActive
      });
    }
  });

  return eligibleUsers;
};